import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'O projektu',
    href: '#o-projektu-stranka'
  }, {
    name: 'Galerie',
    href: '#cela-galerie'
  }, {
    name: 'Výhody',
    href: '#vyhody'
  }, {
    name: 'Lokalita',
    href: '#lokalita'
  }, {
    name: 'Nabídka bytů',
    href: '#nabidka-bytu'
  }, {
    name: 'Kontakt',
    href: '#kontakt'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-base-cream/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-210">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-211">
        <a href="#" className={`font-heading text-2xl tracking-wide transition-colors ${isScrolled ? 'text-primary' : 'text-white'}`} data-id="element-212">
          <b data-id="element-213">SvatyVaclav</b>.living
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-214">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-accent ${isScrolled ? 'text-base-dark' : 'text-white/90'}`} data-id="element-215">
              {link.name}
            </a>)}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-216">
          {isMobileMenuOpen ? <XIcon className={isScrolled ? 'text-base-dark' : 'text-white'} data-id="element-217" /> : <MenuIcon className={isScrolled ? 'text-base-dark' : 'text-white'} data-id="element-218" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-base-cream shadow-lg border-t border-gray-100 py-4 px-6 flex flex-col space-y-4" data-id="element-219">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base-dark font-medium py-2 border-b border-gray-100 last:border-none" data-id="element-220">
              {link.name}
            </a>)}
        </div>}
    </nav>;
}